import { render } from "./DiscountsTable.vue?vue&type=template&id=289a6fc4"
import script from "./DiscountsTable.vue?vue&type=script&lang=js"
export * from "./DiscountsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__